import {Radio} from "antd";
import {Controller, useFormContext} from "react-hook-form";
import {
  StyledDiscountFormContainer,
  StyledDiscountFormItem,
} from "../../../create-discount-code/styles/discount-form.styles";

export function DiscountCodeSettingsFormFieldV2() {
  const {control} = useFormContext();
  return (
    <StyledDiscountFormContainer>
      <div className="form-header">Settings</div>
      <div className="form-content">
        <StyledDiscountFormItem style={{marginBottom: 0}}>
          <div className="label-row">
            <label>Discount status</label>
          </div>
          <Controller
            control={control}
            name="disable_discount"
            render={({field: {onChange, value, onBlur, ref}, fieldState: {error}}) => (
              <>
                <Radio.Group value={value} onBlur={onBlur} ref={ref} onChange={onChange}>
                  <Radio value={"enabled"}>Enabled</Radio>
                  <Radio value={"disabled"}>Disabled</Radio>
                </Radio.Group>
                {error && (
                  <div role="alert" className="ant-form-item-explain-error">
                    {error.message}
                  </div>
                )}
              </>
            )}
          />
        </StyledDiscountFormItem>
      </div>
    </StyledDiscountFormContainer>
  );
}
